import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit{
  @Input() bsModalRef?: BsModalRef;
  @Input() modalRef?: BsModalRef;
  @Input() confirmQuestion = 'Are you sure you want to confirm this Item';
  @Input() itemName? = "";
  @Input() isDecline: boolean ;
  @Input() confirm: {text: string, loading: boolean}
  @Output() getEvent = new EventEmitter()
form! : FormGroup 

constructor(
  private fb: FormBuilder
) {}


ngOnInit(): void {
  this.form = this.fb.group({
    declineReason: ''
  })
}

  onConfrim() {
    // console.log(reason)
    if (!this.isDecline) {

      this.getEvent.emit({type: 'confirm', data: null})
    } else {
      this.getEvent.emit({type: 'confirm', data: this.form.value})

    }
  }

}
